import React from 'react'
import CloudOptixMappingForm from './CloudOptixMappingForm';
import CloudOptixCredentialForm from './CloudOptixCredentialForm';
import GenericPullConfigListing from '../GenericPullConfigListing';

export default function CloudOptixConfigListing(props) {

    return (
        <GenericPullConfigListing
            {...props}
            toolName={props.name}
            MappingForm={CloudOptixMappingForm}
            CredentialsForm={CloudOptixCredentialForm}
            componentName="Account Name"
            componentKey="accountName"
        />
    )
}